import Vue from 'vue'
import { AlarmType } from '@/modules/configurationModule/detail/notifications/models/alarms'

class AlarmTypeServices extends Vue {
    async getAllAlarmTypes(): Promise<AlarmType[]> {
        const response = await this.axios.get('/configuration/alarmTypes')
        return response.data
    }
}

export const alarmTypeServices = new AlarmTypeServices()
